let base_url = process.env.VUE_APP_PUBLIC_PATH || "/";

module.exports = {
    publicPath: base_url,
    transpileDependencies: ["@vueform"],
    chainWebpack: config => {
        config.module.rules.delete('eslint');
    }
}